<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button returnUrl="/security/1"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <certificate-form-global :mode="mode" :readonly="!isEditable" v-model="certificateConfig" v-else></certificate-form-global>
      <b-row class="justify-content-end no-gutter">
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('view')">
          <span>{{ $t('common.cncl') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3"
          @click="switchMode('edit')">
          <span>{{ $t('administration.edit') }}</span>
        </b-button>
        <b-button variant="primary" v-if="!isEditable && formType !== 'add'"
          class="mx-3" 
          @click="deleteCertificate">
          <i class="fa-light fa-trash"></i> 
          <span>{{ $t('rights.delete') }}</span>
        </b-button>
        <b-button variant="primary" v-if="isEditable && formType !== 'add'"
          class="mx-3"
          @click="editCertificate">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'add'"
          class="mx-3"
          @click="createCertificate">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import backButton from "@/components/common/backButton.vue"
import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'


export default {
  name: 'CertificateForm',
  components: {
    'back-button': backButton,
    'certificate-form-global': CertificateFormGlobal,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner 
    
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      activateSpinner: false,
      certificateConfig: {},
      currentCertificate: {},
      formType: 'add',
      pageTitle: ''
    }
  },
  created () {
    this.activateSpinner = true
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_cert')
    if(this.id !== '-1' && (this.mode === "view" || "edit")) {
      this.getCertificate()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    createCertificate(){
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        name: this.certificateConfig.name,
        certificate: this.certificateConfig.certificate,
        type: this.certificateConfig.type,
        password: this.certificateConfig.password,
        passwordVerif: this.certificateConfig.passwordVerif,
        startDate: this.certificateConfig.startDate,
        endDate: this.certificateConfig.endDate,
        commonName: this.certificateConfig.cn,
        idPod: this.certificateConfig.idPod
      }
      this.$engine.security.certificates.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.cert_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.cert_addition_error'))
      })
    },
    deleteCertificate(){
      let that = this

      this.$f7.modal({
        title: this.$t('common.security.cert_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id: that.id
              }
              that.$engine.security.certificates.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.security.cert_deleted'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
                loadPage(that, {url: '/security/1'})
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.security.cert_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editCertificate(){
      let that = this

      if (this.formHasError()) {
        return
      }
      
      let params = {
        name: this.certificateConfig.name,
        id: this.id,
        certificate: this.certificateConfig.certificate,
        type: this.certificateConfig.type,
        password: this.certificateConfig.password,
        passwordVerif: this.certificateConfig.passwordVerif,
        startDate: this.certificateConfig.startDate,
        endDate: this.certificateConfig.endDate,
        commonName: this.certificateConfig.cn,
        idPod: this.certificateConfig.idPod
      }
      this.$engine.security.certificates.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.security.cert_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/security/1'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.security.cert_edit_error'))
      })
    },
    formHasError () {
      if (this.certificateConfig.name === undefined || this.certificateConfig.name.length === 0) {
        this.okMessageBox(this.$t('common.security.certif_name_missing'))
        return true
      }
      if (this.certificateConfig.certificate === undefined || this.certificateConfig.certificate.length === 0) {
        this.okMessageBox(this.$t('common.security.certif_desc_missing'))
        return true
      }
      if (this.certificateConfig.type === undefined || this.certificateConfig.type === "0") {
        this.okMessageBox(this.$t('common.security.certif_type_missing'))
        return true
      }
      if (this.certificateConfig.password === undefined || this.certificateConfig.password.length === 0) {
        this.okMessageBox(this.$t('common.security.password_missing'))
        return true
      }
      if (this.certificateConfig.passwordVerif === undefined || this.certificateConfig.passwordVerif.length === 0) {
        this.okMessageBox(this.$t('common.security.password_verify_missing'))
        return true
      }
      if (this.certificateConfig.passwordVerif !== this.certificateConfig.password) {
        this.okMessageBox(this.$t('common.security.passwords_not_matching'))
        return true
      }
      if (this.certificateConfig.startDate === undefined || this.certificateConfig.startDate.length === 0) {
        this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
        return true
      }
      if (this.certificateConfig.endDate === undefined || this.certificateConfig.endDate.length === 0) {
        this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
        return true
      }
      if (this.certificateConfig.cn === undefined || this.certificateConfig.cn.length === 0) {
        this.okMessageBox(this.$t('common.security.certif_cn_missing'))
        return true
      }
      if (this.certificateConfig.idPod === undefined || this.certificateConfig.idPod === '') {
        this.okMessageBox(this.$t('common.security.pod_missing'))
        return true
      }
      return false
    },
    getCertificate () {
      this.$engine.security.certificates.fetch({id: this.id})
      .then(resp => {
        let that = this
        let certificatesList = {}
        certificatesList = resp.data.certificates
        that.updateCertificate(certificatesList)
      })
    },
    fillFields () {
      this.certificateConfig = this.currentCertificate
      this.activateSpinner = false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      this.formType = mode
    },
    updateCertificate(certificatesList){
      this.currentCertificate = certificatesList[0]
      
      this.fillFields()
    }
}
}

</script>
